/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PendingDocShareProjectPrefill_ClientActorFragment = { __typename: 'PendingDocShareClientActor', type: Types.DocActorType, companyOrIndividual: Types.DocActorCompanyOrIndividual, companyName?: string | null, firstname?: string | null, familyname?: string | null, salutation?: Types.Salutation | null, email?: string | null, matchedCrmCompanyId?: string | null, matchedCrmCompanyTitle?: string | null, matchedCrmCompanyCreatedAt?: any | null };

export type PendingDocShareProjectPrefill_ResultFragment = { __typename: 'PendingDocShareProjectPrefillResult', id: string, docTitle: string, categories: Array<string>, projectTypes: Array<Types.ProjectType>, quoteNumber: string, quoteDate: any, quoteNetTotal: number, sharingOrganisationTitle: string, buildingAddress?: { __typename: 'Address', city: string, postalCode: string, countryCode: string, streetLines1: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, clientActor?: { __typename: 'PendingDocShareClientActor', type: Types.DocActorType, companyOrIndividual: Types.DocActorCompanyOrIndividual, companyName?: string | null, firstname?: string | null, familyname?: string | null, salutation?: Types.Salutation | null, email?: string | null, matchedCrmCompanyId?: string | null, matchedCrmCompanyTitle?: string | null, matchedCrmCompanyCreatedAt?: any | null } | null };

export type PendingDocShareProjectPrefillQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PendingDocShareProjectPrefillQuery = { pendingDocShareProjectPrefill: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PendingDocShareProjectPrefillResult', id: string, docTitle: string, categories: Array<string>, projectTypes: Array<Types.ProjectType>, quoteNumber: string, quoteDate: any, quoteNetTotal: number, sharingOrganisationTitle: string, buildingAddress?: { __typename: 'Address', city: string, postalCode: string, countryCode: string, streetLines1: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, clientActor?: { __typename: 'PendingDocShareClientActor', type: Types.DocActorType, companyOrIndividual: Types.DocActorCompanyOrIndividual, companyName?: string | null, firstname?: string | null, familyname?: string | null, salutation?: Types.Salutation | null, email?: string | null, matchedCrmCompanyId?: string | null, matchedCrmCompanyTitle?: string | null, matchedCrmCompanyCreatedAt?: any | null } | null } };

export const PendingDocShareProjectPrefill_ClientActorFragmentDoc = gql`
    fragment PendingDocShareProjectPrefill_ClientActor on PendingDocShareClientActor {
  type
  companyOrIndividual
  companyName
  firstname
  familyname
  salutation
  email
  matchedCrmCompanyId
  matchedCrmCompanyTitle
  matchedCrmCompanyCreatedAt
}
    `;
export const PendingDocShareProjectPrefill_ResultFragmentDoc = gql`
    fragment PendingDocShareProjectPrefill_Result on PendingDocShareProjectPrefillResult {
  id
  docTitle
  categories
  projectTypes
  buildingAddress {
    city
    postalCode
    countryCode
    streetLines1
    location {
      lat
      lng
    }
  }
  clientActor {
    ...PendingDocShareProjectPrefill_ClientActor
  }
  quoteNumber
  quoteDate
  quoteNetTotal
  sharingOrganisationTitle
}
    ${PendingDocShareProjectPrefill_ClientActorFragmentDoc}`;
export const PendingDocShareProjectPrefillDocument = gql`
    query PendingDocShareProjectPrefill($id: ID!) {
  pendingDocShareProjectPrefill(id: $id) {
    __typename
    ... on PendingDocShareProjectPrefillResult {
      ...PendingDocShareProjectPrefill_Result
    }
  }
}
    ${PendingDocShareProjectPrefill_ResultFragmentDoc}`;

/**
 * __usePendingDocShareProjectPrefillQuery__
 *
 * To run a query within a React component, call `usePendingDocShareProjectPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingDocShareProjectPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingDocShareProjectPrefillQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePendingDocShareProjectPrefillQuery(baseOptions: Apollo.QueryHookOptions<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables> & ({ variables: PendingDocShareProjectPrefillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>(PendingDocShareProjectPrefillDocument, options);
      }
export function usePendingDocShareProjectPrefillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>(PendingDocShareProjectPrefillDocument, options);
        }
export function usePendingDocShareProjectPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>(PendingDocShareProjectPrefillDocument, options);
        }
export type PendingDocShareProjectPrefillQueryHookResult = ReturnType<typeof usePendingDocShareProjectPrefillQuery>;
export type PendingDocShareProjectPrefillLazyQueryHookResult = ReturnType<typeof usePendingDocShareProjectPrefillLazyQuery>;
export type PendingDocShareProjectPrefillSuspenseQueryHookResult = ReturnType<typeof usePendingDocShareProjectPrefillSuspenseQuery>;
export type PendingDocShareProjectPrefillQueryResult = Apollo.QueryResult<PendingDocShareProjectPrefillQuery, PendingDocShareProjectPrefillQueryVariables>;